<template>
  <div class="business-home-page">
    <PresentationBlock>
      <div class="biz-hero-container__row">
        <div class="biz-hero-container__inner--left">
          <span class="biz-hero-container__eyebrow">m2VET dla biznesu</span>
          <h2>Zacznij razem z nami</h2>
          <p>
            Prowadzisz gabinet weterynaryjny albo salon groomerski? Załóż konto usługodawcy w naszym serwisie.
            m2VET dla biznesu to narzędzie, które pozwoli Ci stworzyć własną wizytówkę.
            Ponadto za pośrednictwem serwisu będziesz mógł/mogła prowadzić kalendarz, przez który Twoi klienci będą mogli umawiać się na wizyty.
          </p>

          <img
              src="@/assets/illustrations/business/offer-item.svg"
              class="biz-hero-container__inner--left__hero-mobile"
              alt=""
          >

          <div class="biz-hero-container__inner--left__scroll-down">
            <span>
              <router-link to="#offer">Zobacz naszą ofertę</router-link>
            </span>
            <img src="@/assets/icons/arrow-down-short.svg" alt="">
          </div>
        </div>

        <div class="biz-hero-container__inner--right">
          <img src="@/assets/illustrations/business/offer-item.svg" alt="">
        </div>
      </div>
    </PresentationBlock>

    <PresentationBlock v-if="! currentUser">
      <div class="business-register">
        <div class="business-register__intro">
          <span class="business-register__eyebrow">Dołącz do m2VET</span>
          <h2>Zarejestruj konto biznesowe</h2>
          <p>
            Wybierz, czy chcesz zarejestrować się jako niezależny specjalista, czy jako placówka,
            która może prezentować swój zespół i ofertę w serwisie.
          </p>

          <div class="business-register__benefits">
            <div>
              <strong>Specjalista</strong>
              <span>dla osób prowadzących usługi i kalendarz wizyt</span>
            </div>
            <div>
              <strong>Placówka</strong>
              <span>dla gabinetów, klinik i miejsc zrzeszających specjalistów</span>
            </div>
          </div>
        </div>

        <div class="business-register__card">
          <div class="business-register__mode-button">
            <button
                type="button"
                :class="{ 'business-register__mode-button__selected': selectedMode === 'biz' }"
                @click="() => { selectedMode = 'biz'; firmRegistration = false }"
            >
              Specjalista
            </button>
            <button
                type="button"
                :class="{ 'business-register__mode-button__selected': selectedMode === 'firm' }"
                @click="() => { selectedMode = 'firm'; firmRegistration = true }"
            >
              Placówka
            </button>
          </div>

          <Form @submit="handleRegister" :validation-schema="schema" v-if="!firmRegistration">
            <div class="business-register__form">
              <div class="business-register__form-grid">
                <div class="form-group">
                  <label for="email">Email <span class="required">(wymagane)</span></label>
                  <Field name="email" type="email" class="form-control" autocomplete="email" />
                  <ErrorMessage name="email" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="firstname">Imię <span class="required">(wymagane)</span></label>
                  <Field name="firstname" type="text" class="form-control" autocomplete="name"/>
                  <ErrorMessage name="firstname" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="lastname">Nazwisko <span class="required">(wymagane)</span></label>
                  <Field name="lastname" type="text" class="form-control" autocomplete="family-name"/>
                  <ErrorMessage name="lastname" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="password">Hasło <span class="required">(wymagane)</span></label>
                  <Field name="password" type="password" class="form-control" autocomplete="new-password"/>
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="passwordConfirmation">Potwierdź hasło <span class="required">(wymagane)</span></label>
                  <Field id="passwordConfirmation" name="passwordConfirmation" type="password" class="form-control" />
                  <ErrorMessage name="passwordConfirmation" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="name">Nazwa działalności</label>
                  <Field name="name" type="text" class="form-control" autocomplete="organization"/>
                  <ErrorMessage name="name" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="phone">Numer telefonu</label>
                  <Field name="phone" type="tel" class="form-control" autocomplete="tel"/>
                  <ErrorMessage name="phone" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="category">Kategoria</label>
                  <Field name="category_id" as="select" class="form-control" v-model="selectedCategory">
                    <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.name }}</option>
                  </Field>
                  <ErrorMessage name="category" class="error-feedback" />
                </div>
              </div>

              <div class="form-group consent-group">
                <label>
                  Rejestrując się, akceptujesz
                  <RouterLink to="/statute">regulamin</RouterLink>
                  i
                  <RouterLink to="/privacy">politykę prywatności</RouterLink>
                  serwisu.
                </label>

                <span>{{ !isRecommendEmailOpen ? 'Czy ktoś polecił Ci m2VET?' : 'Wpisz adres e-mail osoby polecającej' }}</span>
                <span v-if="!isRecommendEmailOpen" class="recommend-open-btn" role="button" @click="isRecommendEmailOpen = true">Tak</span>
                <input v-if="isRecommendEmailOpen" type="text" class="recommend-email form-control" placeholder="adres e-mail" v-model="recommendEmail">

                <button class="submit-btn" :disabled="loading">
                  <span v-show="loading" class="spinner-border"></span>
                  Zarejestruj się jako specjalista
                </button>
              </div>
            </div>
          </Form>

          <Form @submit="handleFirmRegister" v-if="firmRegistration" :validation-schema="schemaFirm">
            <div class="business-register__form">
              <div class="business-register__form-grid">
                <div class="form-group">
                  <label for="email">Email <span class="required">(wymagane)</span></label>
                  <Field name="email" type="email" class="form-control" autocomplete="email"/>
                  <ErrorMessage name="email" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="name">Nazwa działalności <span class="required">(wymagane)</span></label>
                  <Field name="name" type="text" class="form-control" autocomplete="organization"/>
                  <ErrorMessage name="name" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="password">Hasło <span class="required">(wymagane)</span></label>
                  <Field name="password" type="password" class="form-control" autocomplete="new-password"/>
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="passwordConfirmation">Potwierdź hasło <span class="required">(wymagane)</span></label>
                  <Field id="passwordConfirmation" name="passwordConfirmation" type="password" class="form-control" />
                  <ErrorMessage name="passwordConfirmation" class="error-feedback" />
                </div>
              </div>

              <div class="form-group consent-group">
                <label>
                  Rejestrując się, akceptujesz
                  <RouterLink to="/statute">regulamin</RouterLink>
                  i
                  <RouterLink to="/privacy">politykę prywatności</RouterLink>
                  serwisu.
                </label>

                <span>{{ !isRecommendEmailOpen ? 'Czy ktoś polecił Ci m2VET?' : 'Wpisz adres e-mail osoby polecającej' }}</span>
                <span v-if="!isRecommendEmailOpen" class="recommend-open-btn" role="button" @click="isRecommendEmailOpen = true">Tak</span>
                <input v-if="isRecommendEmailOpen" type="text" class="recommend-email form-control" placeholder="adres e-mail" v-model="recommendEmail">

                <button class="submit-btn" :disabled="loading">
                  <span v-show="loading" class="spinner-border"></span>
                  Zarejestruj się jako placówka
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </PresentationBlock>

    <PresentationBlock>
      <div class="section__head section__head--center" id="offer">
        <h2>Co oferujemy?</h2>
        <p>Kompleksowe wsparcie dla gabinetów, klinik i specjalistów.</p>
      </div>

      <OfferVue />
    </PresentationBlock>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import OfferVue from '@/components/HomeComponents/biz/Offer.vue';
import axios from 'axios';
import PresentationBlock from "@/components/HomeComponents/biz/Partials/PresentationBlock.vue";
import {useAuthStore} from "@/stores/auth";
import { useAppStore } from '@/stores/app';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { RouterLink } from 'vue-router';
import { useReCaptcha } from 'vue-recaptcha-v3';

export default {
  name: 'BusinessHomePage',
  setup() {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    useMeta({
      title: 'Dla biznesu',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
      executeRecaptcha,
      recaptchaLoaded
    }
  },
  data() {
    const schema = yup.object().shape({
      email: yup
          .string()
          .required("email jest wymagany")
          .email("email jest nieprawidłowy")
          .max(50, "maksymalnie 50 znaków")
          .min(6, "minimum 6 znaków"),
      firstname: yup
          .string()
          .required("imię jest wymagane")
          .min(3, "minimum 3 znaki")
          .max(30, "maksymalnie 30 znaków"),
      lastname: yup
          .string()
          .required("nazwisko jest wymagane")
          .min(3, "minimum 3 znaki")
          .max(30, "maksymalnie 40 znaków"),
      password: yup
          .string()
          .required("hasło jest wymagane")
          .min(8, "minimum 8 znaków")
          .max(40, "maksymalnie 40 znaków"),
      passwordConfirmation: yup
          .string()
          .required("potwierdź hasło")
          .oneOf([yup.ref('password')], 'Hasła nie są takie same'),
      name: yup
          .string()
          .min(3, "minimum 3 znaki")
          .max(20, "maksymalnie 20 znaków"),
      phone: yup
          .string()
          .length(9, "wpisz numer telefonu bez kierunkowego i bez spacji")
          .matches(/(^[0-9]*$)/, 'nieprawidłowy numer telefonu')
    });

    const schemaFirm = yup.object().shape({
      email: yup
          .string()
          .required("email jest wymagany")
          .email("email jest nieprawidłowy")
          .max(50, "maksymalnie 50 znaków")
          .min(6, "minimum 6 znaków"),
      password: yup
          .string()
          .required("hasło jest wymagane")
          .min(8, "minimum 8 znaków")
          .max(40, "maksymalnie 40 znaków"),
      passwordConfirmation: yup
          .string()
          .required("potwierdź hasło")
          .oneOf([yup.ref('password')], 'Hasła nie są takie same'),
      name: yup
          .string()
          .required("nazwa jest wymagana")
          .min(3, "minimum 3 znaki")
          .max(20, "maksymalnie 20 znaków"),
    });

    return {
      reviews: null,
      subscriptions: [],
      selectedMode: 'biz',
      loading: false,
      schema,
      schemaFirm,
      categories: [],
      selectedCategory: '',
      firmRegistration: false,
      isRecommendEmailOpen: false,
      recommendEmail: ''
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    loggedIn() {
      return this.authStore.loggedIn;
    },
  },
  components: {
    PresentationBlock,
    OfferVue,
    Form,
    Field,
    ErrorMessage,
    RouterLink
  },
  mounted() {
    this.getReviews();
    this.getSubscriptions();
    this.getCategories();
  },
  methods: {
    getReviews() {
      axios.get('/CmsAll').then(res => {
        this.reviews = res.data.filter(item => item.title.includes('Opinia'));
      }).catch(() => {});
    },
    getSubscriptions() {
      axios.post('/SubscriptionSearch', {
        page: 1,
        limit: 100
      }).then(res => {
        this.subscriptions = res.data.items;
      }).catch(() => {});
    },
    async getRecaptchaToken(actionName) {
      try {
        if (!this.recaptchaLoaded || !this.executeRecaptcha) {
          this.appStore.setIsAlert('Moduł reCAPTCHA nie został poprawnie załadowany.');
          return null;
        }

        await this.recaptchaLoaded();
        const token = await this.executeRecaptcha(actionName);

        if (!token) {
          this.appStore.setIsAlert('Nie udało się zweryfikować reCAPTCHA. Spróbuj ponownie.');
          return null;
        }

        return token;
      } catch (e) {
        this.appStore.setIsAlert('Błąd reCAPTCHA. Odśwież stronę i spróbuj ponownie.');
        return null;
      }
    },
    async handleRegister(user, { resetForm }) {
      user.role_id = 2;
      user.category_id = this.selectedCategory || user.category_id;

      if (this.recommendEmail) {
        user.recommender_email = this.recommendEmail;
      }

      if (!user.name || !user.phone) {
        this.appStore.setIsAlert('Wypełnij nazwę firmy i telefon');
        return;
      }

      const recaptchaToken = await this.getRecaptchaToken('register_user');
      if (!recaptchaToken) {
        return;
      }

      user.recaptcha_token = recaptchaToken;
      this.loading = true;

      this.authStore.register(user).then(
          () => {
            this.loading = false;
            resetForm();
            this.appStore.setIsSuccess('Na Twój adres e-mail wysłaliśmy link potwierdzający. Kliknij go.');
            this.$router.push('/');
          },
          (error) => {
            this.loading = false;
            if (String(error?.response?.status || '').charAt(0) === '4') {
              this.appStore.setIsAlert('Wypełnij wszystkie pola');
            } else if (String(error?.response?.status || '').charAt(0) === '5') {
              this.appStore.setIsAlert('Użytkownik o podanym adresie e-mail już istnieje');
            } else {
              this.appStore.setIsAlert('Wystąpił błąd podczas rejestracji');
            }
          }
      );
    },
    async handleFirmRegister(user, { resetForm }) {
      user.role_id = 5;

      if (this.recommendEmail) {
        user.recommender_email = this.recommendEmail;
      }

      const recaptchaToken = await this.getRecaptchaToken('register_firm');
      if (!recaptchaToken) {
        return;
      }

      user.recaptcha_token = recaptchaToken;
      this.loading = true;

      this.authStore.register(user).then(() => {
        this.loading = false;
        resetForm();
        this.appStore.setIsSuccess('Na Twój adres e-mail wysłaliśmy link potwierdzający. Kliknij go.');
        this.$router.push('/');
      }).catch(error => {
        if (error.response && [400, 422].includes(error.response.status)) {
          this.appStore.setIsAlert(error.response.data.message);
        } else {
          this.appStore.setIsAlert('Wystąpił błąd podczas rejestracji');
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    getCategories() {
      axios.get('/Categories').then(res => {
        this.categories = [];
        res.data.forEach((item) => {
          this.categories.push({
            name: item.name,
            id: `${item.id}`
          });
        });
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[this.categories.length - 1].id;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.biz-hero-container {
  width: min(1200px, calc(100% - 32px));
  margin: 28px auto 0;
  padding: 28px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  display: grid;
  grid-template-columns: 1.05fr .95fr;
  gap: 24px;
  align-items: center;

  &__eyebrow {
    display: inline-flex;
    align-self: flex-start;
    padding: 6px 10px;
    border-radius: 999px;
    background: #ecfdf5;
    color: #047857;
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
  }

  &__row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }

  &__inner {
    &--left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 14px;

      h2 {
        margin: 0;
        font-size: clamp(2.8rem, 3vw, 4rem);
        line-height: 1.1;
        color: #111827;
      }

      p {
        margin: 0;
        color: #4b5563;
        line-height: 1.65;
        max-width: 60ch;
        font-size: 1.5rem;
      }

      &__hero-mobile {
        display: none;
      }

      &__scroll-down {
        margin-top: 8px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #047857;
        font-weight: 600;
        font-size: 1.4rem;

        a {
          color: inherit;
          text-decoration: none;
        }

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    &--right {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        max-width: 540px;
        height: auto;
        border-radius: 14px;
      }
    }
  }
}

.business-home-page {
  color: #1f2937;
}

.business-home-page .container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.business-home-page .section {
  position: relative;
  padding: 56px 0;
}

.business-home-page .section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.business-home-page .section__head--center {
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.business-home-page .section__head h2 {
  margin: 0;
  font-size: clamp(2.6rem, 2vw, 3.4rem);
  line-height: 1.15;
  color: #111827;
}

.business-home-page .section__head p {
  margin: 0;
  color: #6b7280;
  max-width: 760px;
  font-size: 1.5rem;
  line-height: 1.55;
}

.business-home-page .section__illustration {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.business-home-page .section__illustration img {
  width: min(100%, 760px);
  height: auto;
  display: block;
}

.business-home-page .offer {
  padding-top: 28px;
}

.business-home-page .pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}

.business-home-page .pricing-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.business-home-page .pricing-card:hover {
  border-color: #10b981;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.business-home-page .pricing-card__head {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.business-home-page .pricing-card__badge {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #047857;
  font-size: 1.2rem;
  font-weight: 700;
}

.business-home-page .pricing-card__head h3 {
  margin: 0;
  color: #111827;
  font-size: 2.2rem;
  line-height: 1.2;
}

.business-home-page .pricing-card__head p {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.business-home-page .pricing-card__head strong {
  color: #f97316;
  font-size: 3rem;
  line-height: 1;
}

.business-home-page .pricing-card__rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
}

.business-home-page .pricing-card__row {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.business-home-page .pricing-card__row span {
  color: #6b7280;
  font-size: 1.3rem;
}

.business-home-page .pricing-card__row b {
  color: #1f2937;
  font-size: 1.45rem;
}

.business-home-page .btn-primary {
  background: #10b981;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
  transition: background-color 0.2s;
}

.business-home-page .btn-primary:hover {
  background: #059669;
  transform: translateY(-1px);
}

.business-register {
  display: grid;
  grid-template-columns: .9fr 1.1fr;
  gap: 28px;
  align-items: stretch;
}

.business-register__intro {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background: linear-gradient(135deg, #064e3b 0%, #047857 58%, #10b981 100%);
  color: #ffffff;
  padding: 28px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}

.business-register__intro::after {
  content: "";
  position: absolute;
  right: -70px;
  bottom: -70px;
  width: 190px;
  height: 190px;
  border-radius: 999px;
  background: rgba(255, 255, 255, .12);
  pointer-events: none;
}

.business-register__eyebrow {
  display: inline-flex;
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, .16);
  color: #d1fae5;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.business-register__intro h2 {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: clamp(2.6rem, 2.4vw, 3.6rem);
  line-height: 1.12;
}

.business-register__intro p {
  position: relative;
  z-index: 1;
  margin: 0;
  color: #ecfdf5;
  font-size: 1.5rem;
  line-height: 1.65;
}

.business-register__benefits {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 12px;
  margin-top: 8px;
}

.business-register__benefits div {
  border: 1px solid rgba(255, 255, 255, .22);
  background: rgba(255, 255, 255, .12);
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.business-register__benefits strong {
  font-size: 1.55rem;
}

.business-register__benefits span {
  color: #d1fae5;
  font-size: 1.35rem;
  line-height: 1.45;
}

.business-register__card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  padding: 24px;
}

.business-register__mode-button {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.business-register__mode-button button {
  background: #ffffff;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  color: #374151;
  font-size: 1.5rem;
  transition: border-color .2s, color .2s, background-color .2s, transform .2s;
}

.business-register__mode-button button:hover {
  border-color: #10b981;
  color: #047857;
  transform: translateY(-1px);
}

.business-register__mode-button__selected {
  background-color: #ecfdf5 !important;
  border-color: #10b981 !important;
  color: #047857 !important;
  font-weight: 700;
}

.business-register__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.business-register__form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.business-home-page .form-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.business-home-page .form-group label {
  font-size: 1.45rem;
  color: #374151;
  display: block;
}

.business-home-page .form-group a {
  color: #10b981;
}

.business-home-page .form-group a:hover {
  color: #059669;
}

.business-home-page .required {
  color: #dc2626;
  font-size: 1.2rem;
}

.business-home-page .form-control {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 1.5rem;
  color: #1f2937;
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
  background: #ffffff;
}

.business-home-page .form-control:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 1px #10b981;
}

.business-home-page .error-feedback {
  font-size: 1.3rem;
  color: #dc2626;
}

.business-home-page .consent-group {
  margin-top: 4px;
}

.business-home-page .consent-group label {
  line-height: 1.55;
}

.business-home-page .consent-group span {
  font-size: 1.4rem;
  color: #4b5563;
}

.business-home-page .recommend-open-btn {
  background-color: #f97316;
  color: #ffffff !important;
  width: fit-content;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color .2s, transform .2s;
}

.business-home-page .recommend-open-btn:hover {
  background-color: #ea6c0a;
  transform: translateY(-1px);
}

.business-home-page .submit-btn {
  margin-top: 6px;
  background: #10b981;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  min-height: 46px;
  padding: 0 18px;
  font-size: 1.55rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color .2s, transform .2s;
}

.business-home-page .submit-btn:hover {
  background: #059669;
  transform: translateY(-1px);
}

.business-home-page .submit-btn:disabled {
  opacity: .7;
  cursor: not-allowed;
  transform: none;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.business-home-page .spinner-border {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: text-bottom;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
  margin-right: 10px;
}

.business-home-page .opinions {
  overflow: hidden;
}

.business-home-page .section-bg {
  position: absolute;
  inset: auto 0 0 0;
  pointer-events: none;
  opacity: .9;
  z-index: 0;
}

.business-home-page .section-bg img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

.business-home-page .opinions .container {
  position: relative;
  z-index: 1;
}

.business-home-page .opinions__opinions-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.business-home-page .empty-state {
  margin: 16px 0 8px;
  min-height: 280px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.business-home-page .empty-state__icon {
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: #ecfdf5;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.12);
}

.business-home-page .empty-state__icon img {
  width: 84px;
  height: 84px;
  display: block;
}

.business-home-page .empty-state h3 {
  margin: 4px 0 0;
  color: #374151;
  font-size: 2rem;
}

.business-home-page .empty-state p {
  margin: 0;
  max-width: 420px;
  font-size: 1.45rem;
}

@media (max-width: 1024px) {
  .business-home-page .opinions__opinions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .business-home-page .pricing-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .business-register {
    grid-template-columns: 1fr;
  }

  .business-register__intro {
    min-height: auto;
  }
}

@media (max-width: 900px) {
  .biz-hero-container {
    grid-template-columns: 1fr;
    padding: 20px;

    &__row {
      flex-direction: column;
      align-items: center;
    }

    &__inner {
      &--left {
        align-items: center;
        text-align: center;

        p {
          max-width: 100%;
        }

        &__hero-mobile {
          display: block;
          width: 100%;
          max-width: 560px;
          border-radius: 12px;
        }
      }

      &--right {
        display: none;
      }
    }
  }
}

@media (max-width: 720px) {
  .business-home-page .section {
    padding: 44px 0;
  }

  .business-home-page .opinions__opinions-grid,
  .business-home-page .pricing-grid {
    grid-template-columns: 1fr;
  }

  .business-register {
    width: min(1200px, calc(100% - 32px));
    gap: 18px;
  }

  .business-register__intro,
  .business-register__card {
    padding: 20px;
  }

  .business-register__form-grid,
  .business-register__mode-button {
    grid-template-columns: 1fr;
  }

  .business-home-page .submit-btn {
    width: 100%;
  }

  .business-home-page .section-bg img {
    height: 160px;
  }
}
</style>